import { render, staticRenderFns } from "./FACSettings.vue?vue&type=template&id=a6b3bba0&scoped=true&"
import script from "./FACSettings.vue?vue&type=script&lang=js&"
export * from "./FACSettings.vue?vue&type=script&lang=js&"
import style0 from "./FACSettings.vue?vue&type=style&index=0&id=a6b3bba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b3bba0",
  null
  
)

export default component.exports